import React from "react";
import { Checkbox } from "components/ui/checkbox"

const dayList = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

const AvailabilityChecklist = ({ value = [], onChange }) => {
  const toggleDay = (day) => {
    if (value.includes(day)) {
      onChange(value.filter((d) => d !== day));
    } else {
      onChange([...value, day]);
    }
  };

  return (
    <div className="border bg-card rounded-2xl p-6 w-full flex flex-col gap-6">
      <div>
        <p className="mb-2 text-base font-bold">Availability</p>
      </div>
      <div className="flex flex-col gap-2">
        {dayList.map((day, index) => {
          const checkboxId = `availability-${day.toLowerCase()}`;
          const isChecked = value.includes(day);

          return (
            <div
              key={index}
              className="flex items-center gap-2 text-sm text-grey-primary font-medium"
            >
              <Checkbox
                id={checkboxId}
                checked={isChecked}
                className="bg-white data-[state=checked]:border-sky-600 data-[state=checked]:bg-sky-600 data-[state=checked]:text-white dark:data-[state=checked]:border-sky-700 dark:data-[state=checked]:bg-sky-700"
                onCheckedChange={() => toggleDay(day)}
              />
              <label htmlFor={checkboxId} className="cursor-pointer">{day}</label>
            </div>
          );
        })}
      </div>
    </div>
  )
}
export default AvailabilityChecklist;
